import { render, staticRenderFns } from "./ReserveCenter.vue?vue&type=template&id=a4c03da4&scoped=true"
import script from "./ReserveCenter.vue?vue&type=script&lang=js"
export * from "./ReserveCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c03da4",
  null
  
)

export default component.exports